import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Toasted from "vue-toasted";
import Axios from "axios";
import "./registerServiceWorker";
import "leaflet/dist/leaflet.css";
import "vazirmatn/Vazirmatn-font-face.css";
import "vazirmatn/misc/Farsi-Digits/Vazirmatn-FD-font-face.css";
import VueZoomer from "vue-zoomer";
import VueKonva from "vue-konva";

Vue.use(VueKonva);
Vue.use(Toasted);
Vue.use(require("vue-moment-jalaali"));
Vue.use(VueZoomer);

Vue.config.productionTip = false;

Vue.prototype.$http = Axios;
Vue.prototype.$http.defaults.baseURL =
  process.env.VUE_APP_URL + "/api/" + process.env.VUE_APP_VERSION;

router.beforeEach((to, from, next) => {
  if (to.name === "PublicLayout") {
    next({ name: "Login" });
  }
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);
  if (nearestWithTitle) {
    var appTitle =
      store.getters.LANGUAGE == "fa"
        ? process.env.VUE_APP_FA_TITLE
        : process.env.VUE_APP_EN_TITLE;
    document.title =
      appTitle +
      ":" +
      vuetify.framework.lang.translator(nearestWithTitle.meta.title);
  }
  store
    .dispatch("isUserLoggedIn")
    .then(response => {
      if (response) {
        if (
          to.name === "Login" ||
          to.name === "SendTAC" ||
          to.name === "ResetPassword"
        ) {
          next("/dashboard");
        } else {
          next();
        }
      } else {
        if (to.matched.some(record => record.meta.anonymousAccess)) {
          next();
        } else {
          next("/login");
        }
      }
    })
    .catch(error => {
      if (error.response.status === 401) {
        next("/");
      } else {
        next("/500");
      }
    });
});

new Vue({
  router,
  store,
  vuetify,
  components: { App },
  template: "<App/>",
  render: h => h(App)
}).$mount("#app");
